<template>
  <div class="info-table-dialog">
    <el-dialog title="告警详情" :visible.sync="API.rowOperations[name].visible" width="100%"
      v-if="API.rowOperations[name].visible" append-to-body custom-class="move-dialog-conent" clasa="dialog-conents">

      <el-tabs type="border-card" class="info-tabs">
        <el-tab-pane label="告警信息" class="tab1-info">
          <el-form :model="alarmInfo" label-width="100px">
            <ElFormItem label="告警名称">{{alarmInfo.name}}</ElFormItem>
            <ElFormItem label="告警设备">{{alarmInfo.deviceN}}</ElFormItem>
            <ElFormItem label="告警类型">{{alarmInfo.alarmType}}</ElFormItem>
            <ElFormItem label="告警时间">{{alarmInfo.createdTime}}</ElFormItem>
            <ElFormItem label="严重性">{{alarmInfo.severity}}</ElFormItem>
            <ElFormItem label="告警触发值">{{alarmInfo.alarmValue}}</ElFormItem>
            <ElFormItem label="恢复触发值">{{alarmInfo.recoverSet}}</ElFormItem>
            <ElFormItem label="告警值">{{alarmInfo.value}}</ElFormItem>
            <ElFormItem label="解除类型">{{alarmInfo.recoverType}}</ElFormItem>
            <ElFormItem label="解除/确认 人">{{alarmInfo.dismissal}}</ElFormItem>
            <ElFormItem label="操作时间">{{alarmInfo.clearTime}}</ElFormItem>
            <ElFormItem label="操作备注">{{alarmInfo.clearRemarks}}</ElFormItem>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="触发详情" class="tab3-info-list">
          <el-table height="470" :data="triggerList" row-class-name="infos-table-style">
            <el-table-column prop="time" label="触发时间"></el-table-column>
            <el-table-column prop="status" label="触发状态" ></el-table-column>
            <el-table-column prop="infoValue" label="告警详细信息" ></el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :page-size="10" :currentPage="currentPage" background
            :total="total" layout="total, prev, pager, next">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>

    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'moveStatisticsDialog',
  props: [
    'temp',
    'dialog',
    'API',
    'name'
  ],
  data () {
    return {
      alarmInfo: {},
      currentPage: 1,
      triggerList: [],
      recordList: []
    }
  },
  created () {
    this.alarmInfo = this.API.rowOperations[this.name].row
    console.log(this.alarmInfo, '------jin moveinfo')
    if (this.API.moveAlarm && this.API.moveAlarmHandle) {
      this.triggerList = this.API.rowOperations[this.name].row.info.slice(0, [9])
      this.recordList = this.API.rowOperations[this.name].row.info
    } else {
      this.triggerList = this.API.rowOperations[this.name].row.recordList.slice(0, [9])
      this.recordList = this.API.rowOperations[this.name].row.recordList
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.currentPage = val
      this.triggerList = this.recordList.slice(val * 10 - 10, [val * 10])
      // this.triggerList = this.API.rowOperations[this.name].row.info.slice(val * 10 - 10, [val * 10])moveInfoDialog
    }
  },
  computed: {
    total () {
      // return this.API.rowOperations[this.name].row.info.length
      return this.recordList.length
    }
  }
}
</script>

<style lang="scss">
.info-table-dialog {

}
.move-dialog-conent {
  .el-dialog__body {
    padding: 20px 0 0 0;
    .info-tabs {
      .el-tabs__content {
        padding: 0;
        .tab1-info {
          padding: 15px;
          background-image: linear-gradient(#ffffff,#fff8dc);
        }
        .tab2-history {
          padding: 15px 15px 35px 15px;
          background-image: linear-gradient(#ffffff,#9fe5ff);
          .history-title {
            color: #409EFF;
          }
        }
        .tab3-info-list {
          padding: 15px 15px 35px 15px;
          background-color: bisque;
          background-image: linear-gradient(#ffffff,#ffb3b3);
          .el-table {
            background: transparent;
            .infos-table-style {
              background: transparent;
            }
          }
        }
      }
    }
  }
}
// .el-table {
//   .infos-table-style {
//     background: transparent;
//   }
// }
</style>
